import get from 'lodash/get';

import * as toastActions from 'actions/toast';

export default function toastReducer(state = [], action) {
  let newState;
  switch (action.type) {
    case toastActions.TOAST_ADD: {
      newState = [...state];
      const existingIndex = newState.findIndex(
        toast => get(action, 'payload.uuid') === toast.uuid,
      );
      if (existingIndex >= 0) newState.splice(existingIndex, 1, action.payload);
      else newState.unshift(action.payload);
      return newState;
    }
    case toastActions.TOAST_REMOVE:
      newState = [...state];
      newState = newState.filter(toast => action.payload !== toast.uuid);
      return newState;
    case toastActions.TOAST_LIST_RESET:
      return [];
    default:
      return state;
  }
}
